import React, { useState, useEffect, useRef } from "react";
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  TablePagination,
  Box,
  Modal,
  TextField 
} from "@mui/material";
import { makeStyles } from "@material-ui/core";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from '@mui/icons-material/Save';
import CloseIcon from '@mui/icons-material/Close';
import { Timestamp } from "firebase/firestore"; // Make sure this is imported
import { db } from "../../../config/firebase";
import { updateDoc } from "firebase/firestore";
import { doc, getDoc,getDocs,where,query ,collection} from "firebase/firestore";

const customStyle = makeStyles({
  root: {
    padding: "10px 40px",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "30px",
  },
  '@media (max-width: 319px)': {
    root: { padding: "60px 5px", width: "90%", gap: "10px" },
  },
  '@media (min-width: 320px) and (max-width: 480px)': {
    root: { padding: "60px 5px", width: "90%", gap: "10px" },
  },
  '@media (min-width: 481px) and (max-width: 768px)': {
    root: { padding: "60px 20px", width: "95%", gap: "25px" },
  },
  '@media (min-width: 769px) and (max-width: 1024px)': {
    root: { padding: "70px 30px", width: "100%", gap: "30px" },
  },
});

const Layout = (props) => {
  const {
    loading,
    documents,
    handleViewImage,
    modalOpen,
    setModalOpen,
    imageURL,
    setImageURL,
    page,
    rowsPerPage,
    handleChangePage,
    handleChangeRowsPerPage,
    machineId,
    userId,
    ppin,
    pinvalidity
  } = props;

  const [imageNotFound, setImageNotFound] = useState(false);
  const [streamOpen, setStreamOpen] = useState(false);
  const wsRef = useRef(null);
  const canvasRef = useRef(null);
  const classes = customStyle();
  const [isEditingPpin, setIsEditingPpin] = useState(false);
  const [newPpin, setNewPpin] = useState(''); 

  const handleViewImageClick = async (docId) => {
    try {
      const imageURL = await handleViewImage(docId);
      if (imageURL) {
        setImageURL(imageURL);
        setImageNotFound(false);
      } else {
        setImageNotFound(true);
      }
      setModalOpen(true);
    } catch (error) {
      setImageNotFound(true);
      console.error("Error fetching image:", error);
    }
  };

 const handleSavePpin = async (userId, newPpin) => {
  try {
    
    const now = new Date();
    const ppinCreated = Timestamp.fromDate(now);
    const ppinExpiry = Timestamp.fromDate(new Date(now.getTime() + 24 * 60 * 60 * 1000)); // +24 hours

    const usersRef = collection(db, "Pusers");
    const q = query(usersRef, where("userId", "==", Number(userId))); // Cast to number if needed
    const querySnapshot = await getDocs(q);

    if (querySnapshot.empty) {
      throw new Error(`No user found with userId: ${userId}`);
    }

    const userDocRef = querySnapshot.docs[0].ref;

    await updateDoc(userDocRef, {
      ppin: newPpin,
      ppin_created: ppinCreated,
      ppin_expiry: ppinExpiry,
    })

    setIsEditingPpin(false);
    window.location.reload(); // Optional

  } catch (error) {
    console.error("Error updating Ppin and timestamps:", error);
  }
};





  const handleCancel = () => {
    setIsEditingPpin(false);
    setNewPpin(ppin); // Reset to original
  };  
  

  return (
    <div className={classes.root}>
   
<Box  sx={{backgroundColor: '#f8fbfd',marginTop:"10px",gap: 2,p: 3}}>
      <Box sx={{display: 'flex',justifyContent: 'space-evenly',alignItems: 'flex-start',flexWrap: 'wrap',gap: 2,p: 3,backgroundColor: 'white',borderRadius: 2,width: '95%'}}>
  {/* Transaction Pin */}
  <Box sx={{ minWidth: 200, textAlign: 'center' }}>
    <Typography variant="body1" sx={{ color: 'black', fontSize: '20px' , fontFamily: 'Inter',}}>
      Transaction Pin:
    </Typography>
    <Typography sx={{ fontWeight: 'bold' ,fontFamily: 'Inter',fontSize: '30px'}}>
      {ppin || "N/A"}
    </Typography>
  </Box>

  {/* Validity */}
  <Box sx={{ minWidth: 200, textAlign: 'center' }}>
    <Typography variant="body1" sx={{ color: 'black', fontSize: '20px' ,fontFamily: 'Inter'}}>
      Validity:
    </Typography>
    <Typography sx={{ fontWeight: 'bold' ,fontFamily: 'Inter',fontSize: '30px'}}>
      {pinvalidity?.toDate().toLocaleString() || "N/A"}
    </Typography>
  </Box>

  {/* Configure Pin Button or Edit Section */}
  <Box sx={{ minWidth: 200, textAlign: 'center' }}>
    {!isEditingPpin ? (
      // <Button
      //   variant="contained"
        
      //   
      // >
        <Button variant="contained" sx={{ textTransform: 'none' ,fontFamily: 'Inter, sans-serif',backgroundColor:"#8b003c",color:"white",'&:hover': {
          backgroundColor: '#8b003c', // keep background same
          color: 'white',             // prevent text turning blue
        },
      }} onClick={() => setIsEditingPpin(true)} 
        ><b>Configure Pin</b></Button>

        
      // </Button>
    ) : (
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, alignItems: 'center' }}>
        <TextField
          size="small"
          value={newPpin ?? ''}
          onChange={(e) => setNewPpin(e.target.value)}
          sx={{ width: 120 }}
          inputProps={{ maxLength: 6 }}
        />
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Button
            variant="contained"
            size="small"
            onClick={() => handleSavePpin(userId, newPpin)}
            sx={{ textTransform: 'none' ,fontFamily: 'Inter, sans-serif',backgroundColor:"#800000",color:"white",'&:hover': {
              backgroundColor: '#800000', // keep background same
              color: 'white',    
              '&:hover': {
                backgroundColor: '#800000', // keep background same
                color: 'white',             // prevent text turning blue
              },         // prevent text turning blue
            },}} 
          >
            Save
          </Button>
          <Button
            variant="contained"
            size="small"
            onClick={handleCancel}
            sx={{ textTransform: 'none' ,fontFamily: 'Inter, sans-serif',backgroundColor:"#800000",color:"white",
            '&:hover': {
              backgroundColor: '#800000', // keep background same
              color: 'white',             // prevent text turning blue
            },}}           >
            Cancel
          </Button>
        </Box>
      </Box>
    )}
  </Box>
</Box>

      
      <TableContainer component={Paper} sx={{
        boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
        borderRadius: '20px',
        overflow: 'auto',
        maxHeight: '400px',
        margin: '20px 0',
        transition: 'all 0.3s ease',
         '&::-webkit-scrollbar': { width: '6px', height: '2px' },
        '&::-webkit-scrollbar-thumb': { backgroundColor: '#ccc', borderRadius: '10px' },
        '&::-webkit-scrollbar-track': { backgroundColor: '#f1f1f1' },
        '&:hover': { transform: 'scale(1.02)', boxShadow: '0px 8px 30px rgba(0, 0, 0, 0.2)' },
        '@media (max-width: 319px)': { width: '80%' },
        '@media (min-width: 320px) and (max-width: 480px)': { width: '90%' },
        '@media (min-width: 481px) and (max-width: 768px)': { width: '90%' },
        '@media (min-width: 769px) and (max-width: 1024px)': { width: '90%' },
      }}>
        <Table stickyHeader>
          <TableHead sx={{ backgroundColor: '#1565c0' }}> 
            <TableRow>
              <TableCell sx={{ backgroundColor: 'white',color: 'black',fontFamily: "'DM Sans', sans-serif", fontSize: '18px'}}><b>Transaction Time</b></TableCell>
              <TableCell sx={{ backgroundColor: 'white',color: 'black',fontFamily: "'DM Sans', sans-serif",fontSize: '18px'}}><b>Transaction ID</b></TableCell>
              <TableCell sx={{ backgroundColor: 'white',color: 'black',fontFamily: "'DM Sans', sans-serif", fontSize: '18px'}}><b>Message</b></TableCell>
              <TableCell sx={{ backgroundColor: 'white',color: 'black' ,fontFamily: "'DM Sans', sans-serif",fontSize: '18px'}}><b>Action</b></TableCell>
            </TableRow>
          </TableHead>
          <TableBody style={{ backgroundColor: 'white' }}>
            {documents.slice().sort((a, b) => (b.timestamp?.seconds || 0) - (a.timestamp?.seconds || 0))
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((doc) => (
                <TableRow key={doc.id} sx={{ height: '30px', transition: 'all 0.2s ease', '&:hover': { backgroundColor: '#ffffff' },fontFamily: "'DM Sans', sans-serif", }}>
                  <TableCell>{doc.timestamp ? new Date(doc.timestamp.seconds * 1000).toLocaleString() : 'No details available'}</TableCell>
                  <TableCell>{doc.id}</TableCell>
                  <TableCell>{doc.message || 'No details available'}</TableCell>
                  <TableCell>
                    <Button variant="contained" sx={{ textTransform: 'none' ,fontFamily: "'DM Sans', sans-serif",backgroundColor:"#8b003c",color:"white",'&:hover': {
                  backgroundColor: '#8b003c', // keep background same
                  color: 'white',             // prevent text turning blue
                },}} onClick={() => handleViewImageClick(doc.id)}><b>View</b></Button>
                                </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        rowsPerPageOptions={[5, 10, 15]}
        component="div"
        count={documents.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />

</Box>

<Modal open={modalOpen} onClose={() => setModalOpen(false)}>
  <Box sx={{
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%) scale(1)',
    opacity: 1,
    animation: modalOpen ? 'popup 0.3s ease-out' : 'none',
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: '12px',
    p: 0.5,
    textAlign: 'center',
    maxWidth: 600,
    width: '90%',
    outline: 'none',
    '&:focus-visible': { outline: 'none' },
    '@media (max-width: 768px)': { width: '85%', p: 1 },
    '@keyframes popup': {
      '0%': { transform: 'translate(-50%, -50%) scale(0.7)', opacity: 0 },
      '100%': { transform: 'translate(-50%, -50%) scale(1)', opacity: 1 }
    }
  }}>
    <Box sx={{ position: 'relative' }}>
      <Button
        onClick={() => setModalOpen(false)}
        sx={{ position: 'absolute', top: 5, right: 5, minWidth: '50px', borderRadius: '50%', color: 'white' }}
      >
        X
      </Button>
    </Box>
    {imageNotFound ? (
      <Typography variant="h6" color="textSecondary">No image found</Typography>
    ) : (
      imageURL && (
        <img 
          src={imageURL} 
          alt="Document Image" 
          style={{ width: '100%', height: 'auto', borderRadius: '8px', boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)' }}
        />
      )
    )}
  </Box>
</Modal>
    </div>
  );
};

export default Layout;
